import {createContext, ReactNode, useContext, useMemo} from 'react';

import {useSearchParams} from 'react-router-dom';

import {IGetGroupDashboardResponse} from '@/dataSource/src/api/groups/entities';

import {SPLIT_BILLS_QUERY_PARAMS} from './constants';

interface SplitBillsGroupViewModelContextType {
  groupId?: string;
  groupName?: string;
  inviterName?: string;
  participantId?: string;
  groupData?: IGetGroupDashboardResponse;
}

const SplitBillsGroupViewModelContext = createContext<
  SplitBillsGroupViewModelContextType | undefined
>(undefined);

export const SplitBillsGroupViewModelProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [searchParams] = useSearchParams();
  const groupId =
    searchParams.get(SPLIT_BILLS_QUERY_PARAMS.GROUP_ID) ?? undefined;
  const groupName =
    searchParams.get(SPLIT_BILLS_QUERY_PARAMS.GROUP_NAME) ?? undefined;
  const inviterName =
    searchParams.get(SPLIT_BILLS_QUERY_PARAMS.INVITER_NAME) ?? undefined;
  const participantId =
    searchParams.get(SPLIT_BILLS_QUERY_PARAMS.SPLIT_USER_ID) ?? undefined;

  const value = useMemo(
    () => ({
      groupId,
      groupName,
      inviterName,
      participantId,
    }),
    [groupId, groupName, inviterName, participantId],
  );

  return (
    <SplitBillsGroupViewModelContext.Provider value={value}>
      {children}
    </SplitBillsGroupViewModelContext.Provider>
  );
};

export const useSplitBillsGroupViewModelProvider = () => {
  const context = useContext(SplitBillsGroupViewModelContext);
  if (!context) {
    throw new Error(
      'useSplitBillsGroupViewModelProvider must be used within SplitBillsGroupViewModelProvider',
    );
  }

  return context;
};
